var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 33,
    viewBox: "0 0 26 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00781 29.4814V4.65211C1.01979 3.76294 1.37828 2.91355 2.00708 2.28475C2.63587 1.65595 3.48527 1.29741 4.37445 1.28543H23.8732C24.003 1.28235 24.1321 1.30565 24.2526 1.35391C24.3731 1.40217 24.4826 1.47438 24.5744 1.56619C24.6662 1.65799 24.7384 1.76747 24.7866 1.88799C24.8349 2.00852 24.8582 2.13758 24.8551 2.26737V32.1467",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88281 8.01562H18.1232",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01172 21.625H24.4743",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01172 26.8164H24.4743",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 32.0059H25.0017",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53796 26.8134C3.22166 26.8472 2.90174 26.8146 2.5988 26.7175C2.29586 26.6205 2.01658 26.4611 1.77883 26.2498C1.54107 26.0385 1.35009 25.7798 1.21819 25.4903C1.0863 25.2008 1.01643 24.887 1.01296 24.5689V24.1481C0.979118 23.8318 1.01172 23.5119 1.10877 23.2089C1.20582 22.906 1.36517 22.6267 1.57651 22.3889C1.78784 22.1512 2.04648 21.9602 2.33595 21.8283C2.62542 21.6964 2.9393 21.6265 3.25739 21.623H3.53796",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53796 32.0067C3.22166 32.0406 2.90174 32.0079 2.5988 31.9109C2.29586 31.8138 2.01658 31.6545 1.77883 31.4432C1.54107 31.2318 1.35009 30.9731 1.21819 30.6837C1.0863 30.3942 1.01643 30.0803 1.01296 29.7623V29.3414C0.979118 29.0251 1.01172 28.7052 1.10877 28.4023C1.20582 28.0994 1.36517 27.8201 1.57651 27.5823C1.78784 27.3446 2.04648 27.1536 2.33595 27.0217C2.62542 26.8898 2.9393 26.8199 3.25739 26.8164H3.53796",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeicon);
export default __webpack_public_path__ + "static/media/typeicon.2e2c1c4cbda7483dfd4488d4d81a39d8.svg";
export { ForwardRef as ReactComponent };